import { B2bCashSource } from '@Common/types/bo/b2b/b2b';
import { GetB2bContractsOneResponse } from '@Common/types/bo/b2b/contracts';

import { contractCampaignActionHandlerChoices } from '@sh4res/bo-common/choices/contracts';
import { ShowFields, ShowSection } from '@sh4res/bo-common/components';
import { SelectChipField } from '@sh4res/bo-common/fields';

type B2bCampaignsProcessingOptionsProps = {
  cashSource: B2bCashSource;
  isSectionTitleLinkedToCashSource?: boolean;
  record: Pick<GetB2bContractsOneResponse, 'campaigns' | 'matching_contributions_enabled'>;
};

export const B2bCampaignsProcessingOptions = ({
  cashSource,
  isSectionTitleLinkedToCashSource = false,
  record,
}: B2bCampaignsProcessingOptionsProps) => {
  const labels: Record<string, string> = {};

  const resource = 'resources.bo_common.b2b.contracts.fields.campaigns';

  labels[`campaigns.${cashSource}.allocation_computed_by`] = `${resource}.allocation_computed_by`;
  labels[`campaigns.${cashSource}.choice_collected_by`] = `${resource}.choice_collected_by`;
  labels[`campaigns.${cashSource}.payout_by`] = `${resource}.payout_by`;
  labels[`campaigns.${cashSource}.matching_contribution_computed_by`] =
    `${resource}.matching_contribution_computed_by`;

  return (
    <ShowSection
      label={
        isSectionTitleLinkedToCashSource
          ? `resources.bo_common.b2b.contracts.campaigns.${cashSource}`
          : 'resources.bo_common.b2b.contracts.menus.campaigns'
      }>
      <ShowFields<GetB2bContractsOneResponse>
        labels={labels}
        fields={{
          [`campaigns.${cashSource}.allocation_computed_by`]: (
            <SelectChipField
              choices={contractCampaignActionHandlerChoices}
              data-testid="BoExternalB2bCampaignsProcessingOptions_AllocationComputedByField"
            />
          ),
          [`campaigns.${cashSource}.choice_collected_by`]: (
            <SelectChipField
              choices={contractCampaignActionHandlerChoices}
              data-testid="BoExternalB2bCampaignsProcessingOptions_ChoiceCollectedByField"
            />
          ),
          [`campaigns.${cashSource}.payout_by`]: (
            <SelectChipField
              choices={contractCampaignActionHandlerChoices}
              data-testid="BoExternalB2bCampaignsProcessingOptions_PayoutByField"
            />
          ),
          ...(record.matching_contributions_enabled && {
            [`campaigns.${cashSource}.matching_contribution_computed_by`]: (
              <SelectChipField
                choices={contractCampaignActionHandlerChoices}
                data-testid="BoExternalB2bCampaignsProcessingOptions_MatchingContributionComputedByField"
              />
            ),
          }),
        }}
      />
    </ShowSection>
  );
};
